<div class="w-[346px] h-[346px] relative ">
    <div class="w-full h-full cursor-pointer" aria-hidden="true" on:click={previewEvevnt}> 
        <img src="{item?.thumb}" alt="" class="object-cover w-full h-full rounded-[16px]">
    </div>
    <div class="absolute right-[12px] top-[12px]">
        {#if item?.type=== 'photo'}
        <PhotoType></PhotoType>
        {:else if item?.type === 'video'}
        <PlayVideoType></PlayVideoType>
        {/if}
    </div>
    {#if item?.type === 'video'}
    <div class="w-[80px] h-[80px] cursor-pointer absolute left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%]" aria-hidden="true" on:click={() => {
        playVideo();
    }}>
        <PlayVideoIcon />
    </div>
    {/if}
    <button class="download-data-btn" on:click={() => {
        downloadData();
    }}>
        <DownloaderIcon />
        <span>Download</span>
    </button>
</div>
<script lang="ts">
    import PhotoType from '$components/icons/PhotoType.svelte'
    import PlayVideoType from '$components/icons/PlayVideoType.svelte'
    import PlayVideoIcon from '$components/icons/PlayVideo.svelte'
    import DownloaderIcon from '$components/icons/DownloaderIcon.svelte'
    import type { DialogPickerItem } from "$lib/types/dialog";
    import type { Optional } from "$lib/types/generic";
    import { openURL } from "$lib/download";
    import { mediaDialog } from '$lib/state/omnibox';
    export let item: Optional<DialogPickerItem> = undefined;
    const downloadData = ()=>{
        if(item?.proxyFile){
            openURL(item?.proxyFile)
        }
    }
    const playVideo = ()=>{
        if(item && item.thumb){
            mediaDialog.update(state => ({...state,type:item.type, isOpen: true,thumb:item?.thumb,url:item?.url,proxyFile:item?.proxyFile}));
        }
    }
    const previewEvevnt = ()=>{
        if(item && item.thumb && item.type === 'photo'){
            playVideo()
        }
    }
</script>

<style lang="less">
.download-data-btn {
    width: 286px;
    height: 44px;
    background-color: #F84095;
    border-radius: 22px;
    font-size: 18px;
    font-weight: bold;
    gap: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    position: absolute;
    z-index: 9;
    left: 50%;
    transform: translate(-50%, 0);
    bottom: 36px;
}
</style>